import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State, SeoPagesResponse } from './types';
import { baseQuery, endpoints } from 'utils/api/endpoints';

export const initialState: State = {
  uploadedFile: null,
};

const slice = createSlice({
  name: 'seo',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'seoApi',
  baseQuery,
  tagTypes: ['SeoPages', 'Sitemap'],
  endpoints: builder => ({
    getPages: builder.query<SeoPagesResponse, any>({
      query: params => ({
        url: endpoints.SEO,
        method: 'GET',
        params,
      }),
      providesTags: ['SeoPages'],
    }),
    updatePage: builder.mutation<any, any>({
      query: ({ id, data }) => ({
        url: `${endpoints.SEO}/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['SeoPages'],
    }),
    getSitemapStatus: builder.query<any, void>({
      query: () => ({
        url: endpoints.SITEMAP + '/status',
        method: 'GET',
      }),
      providesTags: ['Sitemap'],
    }),
    generateSitemap: builder.mutation<any, void>({
      query: () => ({
        url: endpoints.SITEMAP + '/generate-sitemap-xml',
        method: 'POST',
      }),
      invalidatesTags: ['Sitemap'],
    }),
  }),
});

export const { actions: SeoAction } = slice;

export const useSeoSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    useGetPagesQuery: api.useLazyGetPagesQuery,
    actions: SeoAction,
    useUpdatePageMutation: api.useUpdatePageMutation,
    useGenerateSitemapMutation: api.useGenerateSitemapMutation,
    useGetSitemapStatusQuery: api.useLazyGetSitemapStatusQuery,
  };
};
